__turbopack_context__.v({
  "badge": "SupportedProjects-module__2htDbG__badge",
  "container": "SupportedProjects-module__2htDbG__container",
  "disclaimer": "SupportedProjects-module__2htDbG__disclaimer",
  "imageContainer": "SupportedProjects-module__2htDbG__imageContainer",
  "project": "SupportedProjects-module__2htDbG__project",
});
